import { actionConst } from '../constants/contractor.constants'
import { authHeader } from '../helpers/auth-header'
import { client } from './';

export const actions = {
	fetchContractorList,
	fetchDocumentContractorList,
	postContractor,
	postDocumentContractor,
};

function fetchContractorList() {
	let rurl = '/warranty/orgs';
	return dispatch => {
		dispatch({
			type: actionConst.FETCH_CONTRACTORS,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchDocumentContractorList() {
	let rurl = '/docs/orgs';
	return dispatch => {
		dispatch({
			type: actionConst.FETCH_DOCUMENT_CONTRACTORS,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function postContractor(v, onCreate) {
	let rurl = '/warranty/orgs';
	const data = {
		...v,
		id: 1,
	}
	return dispatch => {
		client.post(rurl, data, { headers: authHeader() })
			.then(async (response) => {
				dispatch(fetchContractorList())
				if (typeof onCreate === "function") {
					onCreate(response.data?.id);
				}
			})
			.catch(function (error) {
				console.log(error);
			});			
	} 
}

function postDocumentContractor(v, onCreate) {
	const rurl = '/docs/orgs';
	const data = {
		Id: null,
		Name: v.name,
		Inn: v.inn,
		Director: v.directorFio,
	}

	return dispatch => {
		client.post(rurl, data, { headers: authHeader() })
			.then((response) => {
				if (typeof onCreate === "function") {
						onCreate(response.data)
				}
					dispatch(fetchDocumentContractorList()) 
				})
				.catch(function (error) {
					console.log(error);
				});			
		} 	
}
